import {
  ColumnDefinition,
  OuiDataSearchComponent,
  OuiRecordDatasource as OuiDatasource,
  OuiDataTableComponent,
  OuiDialogComponent,
  OuiDialogHeaderComponent,
  OuiRowComponent,
  OuiStackComponent,
  OuiTextComponent,
} from '@aiz-gl/omni-ui';
import { Component, effect, inject, signal } from '@angular/core';
import { DisplayValueComponent } from '../../components/display-value/display-value.component';
import { DownloadButtonComponent } from '../../components/download-button/download-button.component';
import { PageComponent } from '../../components/page/page';
import { BusinessEntity } from '../../models/business-entity.model';
import { BusinessEntityService } from '../../services/business-entity/business-entity.service';
import { BasePageComponent } from '../base/base.component';

@Component({
  selector: 'app-business-entity',
  standalone: true,
  imports: [
    OuiStackComponent,
    OuiDataTableComponent,
    OuiDialogComponent,
    OuiDialogHeaderComponent,
    OuiRowComponent,
    OuiDataSearchComponent,
    DownloadButtonComponent,
    DisplayValueComponent,
    PageComponent,
    OuiTextComponent,
  ],
  templateUrl: './business-entity.component.html',
})
export class BusinessEntityPage extends BasePageComponent {
  businessEntities!: OuiDatasource<BusinessEntity>;

  readonly businessEntitiesColumns: ColumnDefinition<BusinessEntity>[] = [
    {
      columnDef: 'code',
      header: 'Code',
    },
    {
      columnDef: 'name',
      header: 'Name',
    },
  ];

  readonly showDialog = signal<boolean>(false);
  readonly selectedBusinessEntity = signal<BusinessEntity | undefined>(
    undefined,
  );

  readonly businessEntityService = inject(BusinessEntityService);

  constructor() {
    super();

    effect(() => {
      this.businessEntities = new OuiDatasource(
        this.businessEntityService.businessEntities.value(),
      );
    });
  }

  handleRowClick(businessEntity: BusinessEntity) {
    this.selectedBusinessEntity.set(businessEntity);
    this.showDialog.set(true);
  }
}
